import React from 'react'
import { messageme } from '../../../../assets'

const index = ({value}) => {
  return (
    <div className='flex flex-col items-end'>
        <div className='bg-blue-chatBlue sm:max-w-[450px] flex justify-center items-center max-w-[300px]  px-[12px] py-[6px] mr-[15px] rounded-[30px] text-white'>{value}</div>
        <div className='mt-[-2px] mr-[20px]'><img src={messageme} alt="" /></div>
    </div>
  )
}

export default index